module.exports = __webpack_public_path__ + "static/media/IconANTSpring.772862b4.svg";